import { render } from "./CampoOrario.vue?vue&type=template&id=ddbd2e18"
import script from "./CampoOrario.vue?vue&type=script&lang=js"
export * from "./CampoOrario.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__